import adresseGenerer from '@/services/general/genererAdresse';
import * as devisConf from '@/configuration/devisConf';
import genererModeReglement from '@/services/general/genererModeReglement';
import genererDelaiReglement from '@/services/parametrage/generation/genererDelaiReglement';
import genererDelaiReglementDetail from '@/services/parametrage/generation/genererDelaiReglementDetail';

export default function genererIntervenant() {
  const adressePostale = adresseGenerer();
  const modeReglement = genererModeReglement();
  const delaiReglement = genererDelaiReglement();
  const delaiReglementDetail = genererDelaiReglementDetail();
  return {
    nomCommercial: '',
    adressePostale: adressePostale,
    modeReglementId: null,
    modeReglement: modeReglement,
    delaiReglementId: null,
    delaiReglement: delaiReglement,
    delaiReglementDetail: delaiReglementDetail,
    payeur: false,
    donneurOrdre: false,
    mandataire: false,
    annonceur: false,
    repartition: null,
    typeRepartition: devisConf.POURCENTAGE,
    devisCommande: null,
    tiersId: null,
    tiers: {
      prospect: false,
    },
    contactId: null,
    contact: null,
    titre: null,
    destinataire: false,
    destinataireComptable: false,
    compteComptable: null,
    factureParMail: false,
    nvClient: false,
    intervenantContacts: [],
  };
}
